import React from 'react'
import styles from './FluIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate } from './dates'
import Header from './Header'
import SystemNotification from './../Dashboard/SystemNotification'
import ModelTabs from './ModelTabs'
import categoryDisplayOptions from './categoryDisplayOptions'
const BirthTrendDashboard = () => {
  if(window.localStorage.getItem('bt_category')===null|| window.localStorage.getItem('bt_category')=== "undefined")
    {window.localStorage.setItem('bt_category',categoryDisplayOptions[0].value)}
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={"2025-01-01"}
              locationName={"US"}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'fips'}
            >
               <SystemNotification/>
               <Header  />
              <ModelTabs>
                
              </ModelTabs>
             
             
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default BirthTrendDashboard
